module.exports = __webpack_public_path__ + "img/img_brand5.ceb9a9c0.jpg";